import React, { useState } from 'react';
import { Globe, Check, ChevronDown } from 'lucide-react';
import { useTranslation, SUPPORTED_LANGUAGES } from './TranslationContext';
interface TranslationToggleProps {
  size?: 'sm' | 'md' | 'lg';
  showLanguageSelector?: boolean;
}
export const TranslationToggle: React.FC<TranslationToggleProps> = ({
  size = 'md',
  showLanguageSelector = true
}) => {
  const {
    isTranslationEnabled,
    toggleTranslation,
    userLanguage,
    setUserLanguage,
    angelLanguage,
    setAngelLanguage
  } = useTranslation();
  const [showUserLanguages, setShowUserLanguages] = useState(false);
  const [showAngelLanguages, setShowAngelLanguages] = useState(false);
  // Size classes
  const getButtonClasses = () => {
    switch (size) {
      case 'sm':
        return 'px-2 py-1 text-xs';
      case 'lg':
        return 'px-4 py-2 text-sm';
      default:
        return 'px-3 py-1.5 text-xs';
    }
  };
  return <div className="flex flex-col" data-id="element-21590">
      <div className="flex items-center gap-2" data-id="element-21591">
        {/* Translation Toggle Button */}
        <button onClick={toggleTranslation} className={`${getButtonClasses()} ${isTranslationEnabled ? 'bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 border border-blue-200 dark:border-blue-800/30' : 'bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400 border border-gray-200 dark:border-gray-700'} rounded-full flex items-center gap-1.5 transition-colors`} data-id="element-21592">
          <Globe size={size === 'sm' ? 14 : 16} data-id="element-21593" />
          <span data-id="element-21594">
            {isTranslationEnabled ? 'Translation On' : 'Translation Off'}
          </span>
        </button>
        {/* User Language Selector */}
        {showLanguageSelector && isTranslationEnabled && <div className="relative" data-id="element-21595">
            <button onClick={() => {
          setShowUserLanguages(!showUserLanguages);
          setShowAngelLanguages(false);
        }} className={`${getButtonClasses()} bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400 border border-gray-200 dark:border-gray-700 rounded-full flex items-center gap-1.5`} data-id="element-21596">
              <span data-id="element-21597">{SUPPORTED_LANGUAGES[userLanguage].flag}</span>
              <span data-id="element-21598">Your Language</span>
              <ChevronDown size={size === 'sm' ? 14 : 16} data-id="element-21599" />
            </button>
            {showUserLanguages && <div className="absolute top-full left-0 mt-1 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg z-10 w-48 max-h-60 overflow-y-auto" data-id="element-21600">
                {Object.entries(SUPPORTED_LANGUAGES).map(([code, {
            name,
            flag
          }]) => <button key={code} onClick={() => {
            setUserLanguage(code as any);
            setShowUserLanguages(false);
          }} className={`flex items-center gap-2 w-full px-3 py-2 text-left text-sm ${userLanguage === code ? 'bg-blue-50 dark:bg-blue-900/20 text-blue-600 dark:text-blue-400' : 'hover:bg-gray-50 dark:hover:bg-gray-700'}`} data-id="element-21601">
                      <span data-id="element-21602">{flag}</span>
                      <span data-id="element-21603">{name}</span>
                      {userLanguage === code && <Check size={14} className="ml-auto" data-id="element-21604" />}
                    </button>)}
              </div>}
          </div>}
        {/* Angel Language Selector */}
        {showLanguageSelector && isTranslationEnabled && <div className="relative" data-id="element-21605">
            <button onClick={() => {
          setShowAngelLanguages(!showAngelLanguages);
          setShowUserLanguages(false);
        }} className={`${getButtonClasses()} bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400 border border-gray-200 dark:border-gray-700 rounded-full flex items-center gap-1.5`} data-id="element-21606">
              <span data-id="element-21607">{SUPPORTED_LANGUAGES[angelLanguage].flag}</span>
              <span data-id="element-21608">Angel's Language</span>
              <ChevronDown size={size === 'sm' ? 14 : 16} data-id="element-21609" />
            </button>
            {showAngelLanguages && <div className="absolute top-full left-0 mt-1 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg z-10 w-48 max-h-60 overflow-y-auto" data-id="element-21610">
                {Object.entries(SUPPORTED_LANGUAGES).map(([code, {
            name,
            flag
          }]) => <button key={code} onClick={() => {
            setAngelLanguage(code as any);
            setShowAngelLanguages(false);
          }} className={`flex items-center gap-2 w-full px-3 py-2 text-left text-sm ${angelLanguage === code ? 'bg-blue-50 dark:bg-blue-900/20 text-blue-600 dark:text-blue-400' : 'hover:bg-gray-50 dark:hover:bg-gray-700'}`} data-id="element-21611">
                      <span data-id="element-21612">{flag}</span>
                      <span data-id="element-21613">{name}</span>
                      {angelLanguage === code && <Check size={14} className="ml-auto" data-id="element-21614" />}
                    </button>)}
              </div>}
          </div>}
      </div>
    </div>;
};